<template>
  <BaseView title="Vessel Comparison">
    <template #content>
      <v-container
        class="containerView screenBackground comparisonRoot"
        style="max-height: 100%; overflow-x: hidden;"
      >
        <v-row
          class="rowView"
          style="height: 100% !important;"
        >
          <v-col
            class="colView"
            :cols="8"
          >
            <v-row
              class="rowView"
              style="height:25px;"
            >
              <v-col
                class="colView h5"
                style="color: var(--color-text)"
                :cols="12"
              >
                Comparison Configuration
              </v-col>
            </v-row>

            <v-row
              class="rowView"
              style="height: calc(50% - 30px);"
            >
              <v-col
                class="colView"
                :cols="12"
              >
                <v-card
                  class="bodyText"
                  style="background-color: var(--color-surface) !important"
                  :loading="fetchLoading"
                >
                  <v-container class="containerView">
                    <v-row
                      class="rowView configRow"
                      :style="vessComp == 'single' ? 'height:60px;' : 'height:105px;'"
                    >
                      <ThemedRadioGroup
                        v-model="vessComp"
                        row
                        class="smallRadio ma-auto"
                      >
                        <v-radio
                          label="Single vessel"
                          value="single"
                          color="var(--color-text)"
                        />
                        <v-radio
                          label="Sister vessels"
                          value="multi"
                          color="var(--color-text)"
                        />
                      </ThemedRadioGroup>

                      <v-icon style="color: var(--color-text);">
                        event
                      </v-icon>
                      <div
                        class="tableHeader centerAlign mx-1"
                        style="color: var(--color-text);"
                      >
                        Date Ranges
                      </div>

                      <v-btn
                        v-if="vessComp == 'single'"
                        class="mx-1 my-auto"
                        icon
                        color="var(--color-primary)"
                        @click="addDateRange()"
                      >
                        <v-icon style="color: var(--color-secondary);">
                          mdi-plus
                        </v-icon>
                      </v-btn>

                      <v-slide-group
                        v-if="vessComp == 'single'"
                        :key="dateRanges.length"
                        class="ma-1"
                        style="flex: 1 1 auto; min-width: 0; height: 60px;"
                        show-arrows="always"
                      >
                        <v-slide-item
                          v-for="(range, index) in dateRanges"
                          :key="(range.vesselId || 'base') + '-' + index"
                        >
                          <v-menu
                            v-model="range.dateMenu"
                            :close-on-content-click="false"
                            :close-on-click="false"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                          >
                            <template v-slot:activator="{ on }">
                              <ThemedTextField
                                v-model="range.dateText"
                                append-icon="delete"
                                class="mx-1 my-auto rangeInput"
                                color="#4A7EBA"
                                filled
                                rounded
                                background-color="#F5F5F5"
                                style="
                                  max-width: 270px;
                                  min-width: 270px;
                                  font-size: 13px;
                                  height: 100%;
                                "
                                v-on="on"
                                @click:append="deleteDateRange(index)"
                              />
                            </template>

                            <v-col
                              class="colView"
                              style="background-color: #ffffff"
                            >
                              <v-row class="rowView">
                                <v-col
                                  class="colView"
                                  :cols="6"
                                >
                                  <v-date-picker
                                    v-model="range.startDate"
                                    :elevation="0"
                                    no-title
                                    scrollable
                                    color="#4A7EBA"
                                    event-color="#4A7EBA"
                                    :min="range.minDate"
                                    :max="calcMaxDate(range)"
                                    :events="calcRange(range)"
                                  />
                                </v-col>
                                <v-col
                                  class="colView"
                                  :cols="6"
                                >
                                  <v-date-picker
                                    v-model="range.endDate"
                                    :elevation="0"
                                    no-title
                                    scrollable
                                    color="#4A7EBA"
                                    event-color="#4A7EBA"
                                    :min="calcMinDate(range)"
                                    :max="range.maxDate"
                                    :events="calcRange(range)"
                                  />
                                </v-col>
                              </v-row>
                              <v-row class="rowView">
                                <v-spacer />
                                <v-btn
                                  text
                                  color="#4A7EBA"
                                  class="ma-auto"
                                  @click="updateDateRanges(range)"
                                >
                                  OK
                                </v-btn>
                                <v-btn
                                  text
                                  class="ma-auto"
                                  color="#4A7EBA"
                                  @click="range.dateMenu = false"
                                >
                                  Cancel
                                </v-btn>
                              </v-row>
                            </v-col>
                          </v-menu>
                        </v-slide-item>
                      </v-slide-group>

                      <v-slide-group
                        v-else
                        :key="dateRanges.length"
                        class="ma-1"
                        style="flex: 1 1 auto; min-width: 0; height: 105px;"
                        show-arrows="always"
                      >
                        <v-slide-item
                          v-for="(range, index) in dateRanges"
                          :key="(range.vesselId || 'base') + '-' + index"
                        >
                          <v-col class="pa-1">
                            <v-row class="rowView">
                              <v-checkbox
                                v-model="range.checked"
                                :label="range.vessel"
                                :disabled="index == 0"
                                class="smallCheck ma-1"
                              />
                            </v-row>
                            <v-row
                              class="rowView"
                              style="height: 30px"
                            >
                              <v-menu
                                v-model="range.dateMenu"
                                :close-on-content-click="false"
                                :close-on-click="false"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                              >
                                <template v-slot:activator="{ on }">
                                  <ThemedTextField
                                    v-model="range.dateText"
                                    filled
                                    rounded
                                    :disabled="!range.checked"
                                    color="#4A7EBA"
                                    style="
                                      max-width: 240px;
                                      min-width: 240px;
                                      font-size: 13px;
                                      height: 100%;
                                    "
                                    class="mx-1 my-auto rangeInput"
                                    background-color="#F5F5F5"
                                    v-on="on"
                                  />
                                </template>
                                <v-col
                                  class="colView"
                                  style="background-color: #ffffff"
                                >
                                  <v-row class="rowView">
                                    <v-col
                                      class="colView"
                                      :cols="6"
                                    >
                                      <v-date-picker
                                        v-model="range.startDate"
                                        :elevation="0"
                                        no-title
                                        scrollable
                                        color="#4A7EBA"
                                        event-color="#4A7EBA"
                                        :min="range.minDate"
                                        :max="calcMaxDate(range)"
                                        :events="calcRange(range)"
                                      />
                                    </v-col>
                                    <v-col
                                      class="colView"
                                      :cols="6"
                                    >
                                      <v-date-picker
                                        v-model="range.endDate"
                                        :elevation="0"
                                        no-title
                                        scrollable
                                        color="#4A7EBA"
                                        event-color="#4A7EBA"
                                        :min="calcMinDate(range)"
                                        :max="range.maxDate"
                                        :events="calcRange(range)"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row class="rowView">
                                    <v-spacer />
                                    <v-btn
                                      text
                                      color="#4A7EBA"
                                      class="ma-auto"
                                      @click="updateDateRanges(range)"
                                    >
                                      OK
                                    </v-btn>
                                    <v-btn
                                      text
                                      color="#4A7EBA"
                                      class="ma-auto"
                                      @click="range.dateMenu = false"
                                    >
                                      Cancel
                                    </v-btn>
                                  </v-row>
                                </v-col>
                              </v-menu>
                            </v-row>
                          </v-col>
                        </v-slide-item>
                      </v-slide-group>

                      <v-spacer />
                      <v-btn
                        small
                        text
                        color="#4A7EBA"
                        :disabled="disableFetch"
                        class="mx-1 my-auto"
                        @click="fetchFDMData"
                      >
                        Fetch Data
                      </v-btn>
                    </v-row>

                    <v-divider class="mx-2" />

                    <v-row
                      v-if="vessComp == 'single'"
                      class="rowView"
                      style="height: 25px"
                    >
                      <div
                        v-for="(range, idx) in dateRanges"
                        :key="'range-date-' + idx"
                        style="display: inline-flex; align-items: center; color: var(--color-text)"
                      >
                        <div
                          v-if="range.startDate != null && range.endDate != null"
                          class="smallCircle mx-1"
                          :style="'background-color:' + range.color + ';border-color:' + range.color + ';'"
                        />
                        <div
                          v-if="range.startDate != null && range.endDate != null"
                          :key="'range-label-' + idx"
                          class="body1 mx-1 my-auto"
                        >
                          From {{ range.startDate }} to {{ range.endDate }}
                        </div>
                      </div>
                    </v-row>

                    <v-row
                      v-else
                      class="rowView"
                      style="height: 25px"
                    >
                      <div
                        v-for="(range, idx) in dateRanges"
                        :key="'multi-label-' + idx"
                        style="display: inline-flex; align-items: center"
                      >
                        <div
                          v-if="range.checked"
                          class="smallCircle mx-1"
                          :style="'background-color:' + range.color + ';border-color:' + range.color + ';'"
                        />
                        <div
                          v-if="range.checked"
                          class="body1 mx-1 my-auto"
                          style="color: var(--color-text)"
                        />
                        {{ range.vessel }}
                      </div>
                    </v-row>

                    <v-row
                      class="rowView"
                      :style="vessComp == 'single' ? 'height:calc(100% - 115px);' : 'height:calc(100% - 160px);'"
                    >
                      <v-col
                        v-for="param in parameters"
                        :key="param.tag"
                        cols="3"
                        class="colView"
                        style="max-width: 20%; color: var(--color-text)"
                      >
                        <v-row
                          class="rowView"
                          style="height: 64px"
                        >
                          <div
                            v-if="'value' in param"
                            class="tableHeader centerAlign mx-1"
                            style="max-width: 100px"
                          >
                            {{ param.name }} ({{ param.unit }})
                          </div>
                          <ThemedTextField
                            v-if="'value' in param"
                            v-model.number="param.value"
                            type="number"
                            :step="(param.tag === 'Mean_Draft' || param.tag === 'Trim') ? 0.5 : 1"
                            filled
                            rounded
                            background-color="#F5F5F5"
                            hide-details
                            class="mx-1 my-auto rangeInput"
                            style="font-size: 13px; max-width: calc(100% - 100px);"
                          />
                        </v-row>

                        <v-row
                          class="rowView"
                          style="height: calc(100% - 64px);"
                        >
                          <highcharts
                            v-if="histogramData[param.tag]"
                            :key="'h-' + histogramRenderKey + '-' + param.tag"
                            style="width: 100%; height: 100%"
                            :options="histogramData[param.tag]"
                          />
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row
                      class="rowView"
                      style="height: 30px"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        small
                        color="#4A7EBA"
                        class="ma-auto"
                        :disabled="!fdmDataReady || fetchLoading"
                        @click="calculate()"
                      >
                        Calculate
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>

            <v-row
              class="rowView"
              style="height:25px;"
            >
              <v-col
                class="colView h5"
                :cols="12"
                style="color: var(--color-text)"
              >
                Comparison Results
              </v-col>
            </v-row>

            <v-row
              class="rowView"
              style="height: calc(50% - 30px)"
            >
              <v-col
                class="colView"
                :cols="12"
              >
                <v-card
                  class="bodyText"
                  :loading="calcLoading"
                  style="background-color: var(--color-bg) !important"
                >
                  <v-card-text>
                    <v-container class="containerView">
                      <v-row
                        class="rowView"
                        style="height: 100%"
                      >
                        <v-col
                          class="colView"
                          :cols="3"
                        >
                          <highcharts
                            v-if="results['power']"
                            :key="'r-' + resultsRenderKey + '-power'"
                            style="width: 100%; height: 100%"
                            :options="results['power']"
                          />
                        </v-col>
                        <v-col
                          class="colView"
                          :cols="3"
                        >
                          <highcharts
                            v-if="results['powerDiff']"
                            :key="'r-' + resultsRenderKey + '-powerDiff'"
                            style="width: 100%; height: 100%"
                            :options="results['powerDiff']"
                          />
                        </v-col>
                        <v-col
                          ref="parentDiv"
                          v-resize="updateDataTableHeight"
                          class="colView"
                          :cols="6"
                        >
                          <v-data-table
                            style="height: 100%; width: 100%"
                            :height="dataTableHeight - 5"
                            single-select
                            disable-pagination
                            hide-default-footer
                            :headers="columns"
                            :items="gridData"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            class="colView"
            :cols="4"
          >
            <v-row
              class="rowView"
              style="height:25px;"
            >
              <v-col
                class="colView h5"
                style="color: var(--color-text)"
              >
                K-Diagram
              </v-col>

              <!-- Power-Stw Dialog -->
              <StwPower
                v-if="results['powerStw']"
                :dialog-model="dialog"
                title="Power-Stw"
              >
                <template #activatorButton="{ on: buttonOn, attrs: buttonAttrs }">
                  <v-btn
                    text
                    x-small
                    style="color: var(--color-text)"
                    v-bind="buttonAttrs"
                    v-on="buttonOn"
                    @click="dialog = true"
                  >
                    Power-Stw
                  </v-btn>
                </template>

                <template #content>
                  <div style="width: 700px; height: 500px">
                    <highcharts
                      v-if="results['powerStw']"
                      :key="'r-' + resultsRenderKey + '-powerStw-dialog'"
                      style="width: 100%; height: 100%"
                      :options="results['powerStw']"
                    />
                  </div>
                </template>

                <template #cancelButton>
                  <v-btn
                    color="primary"
                    block
                    rounded
                    text
                    @click="dialog = false"
                  >
                    Close
                  </v-btn>
                </template>
              </StwPower>

              <!-- Consumption Power Dialog -->
              <StwPower
                v-if="isCompany5 && results['consumptionPower']"
                :dialog-model="dialogConsumption"
                title="Power-Consumption"
              >
                <template #activatorButton="{ on: buttonOn, attrs: buttonAttrs }">
                  <v-btn
                    text
                    x-small
                    style="color: var(--color-text)"
                    v-bind="buttonAttrs"
                    v-on="buttonOn"
                    @click="dialogConsumption = true"
                  >
                    Power-Consumption
                  </v-btn>
                </template>

                <template #content>
                  <div style="width: 700px; height: 500px">
                    <highcharts
                      v-if="results['consumptionPower']"
                      :key="'r-' + resultsRenderKey + '-consumptionPower-dialog'"
                      style="width: 100%; height: 100%"
                      :options="results['consumptionPower']"
                    />
                  </div>
                </template>

                <template #cancelButton>
                  <v-btn
                    color="primary"
                    block
                    rounded
                    text
                    @click="dialogConsumption = false"
                  >
                    Close
                  </v-btn>
                </template>
              </StwPower>
            </v-row>

            <v-row
              class="rowView"
              style="height: calc(100% - 35px)"
            >
              <v-col
                class="colView"
                :cols="12"
              >
                <v-card
                  class="bodyText"
                  :loading="calcLoading"
                  style="background-color: var(--color-bg) !important"
                >
                  <v-card-text>
                    <v-container class="containerView">
                      <v-row
                        style="height: 50%"
                        class="rowView"
                      >
                        <highcharts
                          v-if="results['powerRPM']"
                          :key="'r-' + resultsRenderKey + '-powerRPM'"
                          style="width: 100%; height: 100%"
                          :options="results['powerRPM']"
                        />
                      </v-row>
                      <v-row
                        style="height: 50%"
                        class="rowView"
                      >
                        <highcharts
                          v-if="results['stwRPM']"
                          :key="'r-' + resultsRenderKey + '-stwRPM'"
                          style="width: 100%; height: 100%"
                          :options="results['stwRPM']"
                        />
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </BaseView>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Highcharts from "highcharts";
import nodata from "highcharts/modules/no-data-to-display";

import StwPower from "../../core/StwPower.vue";
import BaseView from "../components/BaseView.vue";
import ThemedRadioGroup from "@/core/ThemedRadioGroup.vue";
import ThemedTextField from "@/core/ThemedTextField.vue";
import defaultViewSettings from "@/domain/view_settings/data";

nodata(Highcharts);

// ---------- helpers ----------
function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function toYmd(val) {
  if (!val) return null;
  if (typeof val === "string") {
    if (val.length >= 10) return val.substring(0, 10);
    return val;
  }
  try {
    return new Date(val).toISOString().substring(0, 10);
  } catch (e) {
    return null;
  }
}

function safeNumber(x) {
  if (x === null || typeof x === "undefined") return null;
  if (typeof x === "string" && x.trim() === "") return null;
  const n = Number(x);
  return Number.isNaN(n) ? null : n;
}

function buildReqKey(arr) {
  if (!arr || !arr.length) return "";
  return arr
    .map(function (r) {
      return String(r.vesselId) + "|" + String(r.startDate) + "|" + String(r.endDate);
    })
    .sort()
    .join(",");
}

export default {
  name: "Comparison",

  components: {
    StwPower,
    BaseView,
    ThemedRadioGroup,
    ThemedTextField
  },

  data: function () {
    return {
      parameterUpdateTimer: null,
      defaultViewSettings: defaultViewSettings,

      localFdmData: [],
      seriesMeta: [],
      fdmDataReady: false,

      vesselCache: {},
      currentVessel: null,
      isRestoring: false,
      isProgrammaticRangesUpdate: false,

      seq: 0,

      disableFetch: true,
      dialog: false,
      dialogConsumption: false,

      parameters: [
        { tag: "Mean_Draft", name: "Draft", unit: "m", value: null },
        { tag: "Trim", name: "Trim", unit: "m", value: null },
        { tag: "bft_scale", name: "True Wind", unit: "bft", value: null },
        { tag: "LOG_Speed", name: "STW", unit: "kn" },
        { tag: "ME_Power", name: "Power", unit: "kW" }
      ],

      histogramData: {},
      results: {},

      dateRanges: [],
      first: true,
      sisterVessels: [],
      columns: [],
      gridData: [],
      vessComp: "single",

      defaultBinsNum: 15,
      binConfig: {
        LOG_Speed: 12,
        ME_Power: 50
      },

      bucketConfig: {
        Mean_Draft: { step: 0.5, decimals: 1 },
        Trim: { step: 0.5, decimals: 1 },
        bft_scale: { step: 1, decimals: 0 },
        LOG_Speed: { step: 1, decimals: 0 }
      },

      colors: [],
      dataTableHeight: 100,
      fetchLoading: false,
      calcLoading: false,

      histogramRenderKey: 0,
      resultsRenderKey: 0,
      reflowTimer: null,
      dprTimer: null,
      lastDpr: 1,
      fdmRequest: [],
      fdmRequestKey: "",

      // ===== K-Diagram Performance Config =====
      scatterMaxPoints: 8000,           // Max points per scatter series after dedup
      scatterPrecision: {
        rpm: 1,       // RPM: 1 decimal (e.g., 77.5)
        power: 0,     // Power: integer (e.g., 4420)
        speed: 1,     // STW: 1 decimal (e.g., 14.0)
        foc: 1        // FOC: 1 decimal
      }
    };
  },

  computed: {
    ...mapState("main", ["infoDetails"]),

    isCompany5: function () {
      return String(process.env.VUE_APP_COMPANY_ID) === "5";
    },

    selectedVesselNameFromStore: function () {
      const sel = this.$store && this.$store.state && this.$store.state.main
        ? this.$store.state.main.selectedVessel
        : null;
      if (sel && sel.vessel) return sel.vessel;
      if (sel && sel.Vessel) return sel.Vessel;
      return null;
    },

    routeVesselName: function () {
      if (this.$route && this.$route.params && this.$route.params.vessel) {
        return this.$route.params.vessel;
      }
      return null;
    },

    activeVesselName: function () {
      return this.routeVesselName || this.selectedVesselNameFromStore || null;
    },

    ...mapGetters([
      "getVesselsData",
      "getComparisonDates",
      "getComparisonFDMData",
      "getComparisonPower"
    ])
  },

  watch: {
    activeVesselName: {
      immediate: true,
      handler: function (newVessel, oldVessel) {
        if (!newVessel) return;
        if (newVessel === oldVessel && this.currentVessel === newVessel) return;
        this.initForVessel(newVessel);
      }
    },

    getVesselsData: {
      immediate: true,
      handler: function () {
        if (!this.currentVessel && this.activeVesselName) {
          this.initForVessel(this.activeVesselName);
        }
      }
    },

    vessComp: function () {
      if (this.isRestoring) return;
      if (!this.currentVessel) return;
      this.rebuildRangesFromDates(true);
      this.fetchFDMData();
    },

    parameters: {
      deep: true,
      handler: function () {
        if (this.parameterUpdateTimer) clearTimeout(this.parameterUpdateTimer);
        this.parameterUpdateTimer = setTimeout(() => {
          this.setChartDataInternal(this.seq);
        }, 300);
      }
    },

    dateRanges: {
      handler: function () {
        if (this.isRestoring) return;
        if (this.isProgrammaticRangesUpdate) return;
        this.disableFetch = false;
      }
    }
  },

  mounted: function () {
    this.lastDpr = window.devicePixelRatio || 1;

    window.addEventListener("resize", this.scheduleReflow, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.scheduleReflow, { passive: true });
    }
    this.dprTimer = setInterval(this.checkDpr, 250);

    this.scheduleReflow();
  },

  beforeDestroy: function () {
    window.removeEventListener("resize", this.scheduleReflow);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", this.scheduleReflow);
    }
    if (this.dprTimer) clearInterval(this.dprTimer);
    if (this.reflowTimer) clearTimeout(this.reflowTimer);

    if (this.currentVessel) this.saveVesselState(this.currentVessel);
  },

  methods: {
    ...mapActions([
      "fetchComparisonDates",
      "fetchComparisonFDMData",
      "fetchComparisonPower"
    ]),

    // ==================== PERFORMANCE HELPERS ====================

    downsamplePoints: function (points, maxPoints) {
      if (!points || points.length <= maxPoints) return points;
      const step = Math.ceil(points.length / maxPoints);
      const result = [];
      for (let i = 0; i < points.length; i += step) {
        result.push(points[i]);
      }
      return result;
    },

    optimizeScatterData: function (points) {
      return this.downsamplePoints(points, this.scatterMaxPoints);
    },

    // ==================== END PERFORMANCE HELPERS ====================

    roundToNearest: function (value, step) {
      const numValue = safeNumber(value);
      const numStep = safeNumber(step);
      if (value === null || numStep === null || numStep <= 0) return null;
      return Math.round(numValue / numStep) * numStep;
    },

    clearCalculationResults: function () {
      this.results = {};
      this.columns = [];
      this.gridData = [];
      this.resultsRenderKey += 1;
      this.scheduleReflow();
    },

    getSeriesColor: function (index) {
      if (this.seriesMeta && this.seriesMeta[index] && this.seriesMeta[index].color) {
        return this.seriesMeta[index].color;
      }
      return this.getRangeColor(index);
    },

    getSeriesLabel: function (index) {
      if (this.seriesMeta && this.seriesMeta[index] && this.seriesMeta[index].label) {
        return this.seriesMeta[index].label;
      }
      return "Series " + String(index + 1);
    },

    getBinsForTag: function (tag) {
      if (this.binConfig && this.binConfig[tag]) return this.binConfig[tag];
      return this.defaultBinsNum;
    },

    getBucketConfig: function (tag) {
      return this.bucketConfig && this.bucketConfig[tag] ? this.bucketConfig[tag] : null;
    },

    waitForCondition: function (fn, maxMs, intervalMs) {
      const start = Date.now();
      intervalMs = intervalMs || 120;
      maxMs = maxMs || 12000;

      return new Promise(function (resolve) {
        function tick() {
          let ok = false;
          try {
            ok = Boolean(fn());
          } catch (e) {
            ok = false;
          }
          if (ok) return resolve(true);
          if (Date.now() - start >= maxMs) return resolve(false);
          setTimeout(tick, intervalMs);
        }
        tick();
      });
    },

    nextSeq: function () {
      this.seq = this.seq + 1;
      return this.seq;
    },

    isSeqCurrent: function (s) {
      return s === this.seq;
    },

    checkDpr: function () {
      const dpr = window.devicePixelRatio || 1;
      if (dpr !== this.lastDpr) {
        this.lastDpr = dpr;
        this.scheduleReflow();
      }
    },

    scheduleReflow: function () {
      if (this.reflowTimer) clearTimeout(this.reflowTimer);
      this.reflowTimer = setTimeout(() => {
        this.reflowAllCharts();
      }, 600);
    },

    reflowAllCharts: function () {
      this.$nextTick(() => {
        if (Highcharts && Highcharts.charts) {
          Highcharts.charts.forEach(function (chart) {
            if (!chart) return;
            chart.setSize(null, null, false);
            chart.reflow();
          });
        }
        this.updateDataTableHeight();
      });
    },

    roundToStep: function (value, step) {
      const numValue = safeNumber(value);
      const numStep = safeNumber(step);
      if (numValue === null || numStep === null || numStep <= 0) return null;
      return Number((Math.round(numValue / numStep) * numStep).toFixed(6));
    },

    floorToStep: function (value, step) {
      const numValue = safeNumber(value);
      const numStep = safeNumber(step);
      if (numValue === null || numStep === null || numStep <= 0) return null;
      return Number((Math.floor(numValue / numStep) * numStep).toFixed(6));
    },

    ceilToStep: function (value, step) {
      const numValue = safeNumber(value);
      const numStep = safeNumber(step);
      if (numValue === null || numStep === null || numStep <= 0) return null;
      return Number((Math.ceil(numValue / numStep) * numStep).toFixed(6));
    },

    formatBucketLabel: function (value, decimals) {
      if (value === null) return "";
      const n = Number(value);

      if (decimals === 0) return String(Math.round(n));
      if (Number.isInteger(n)) return String(n);

      return n.toFixed(decimals).replace(".", ",").replace(/,0+$/, "");
    },

    getVesselRowByName: function (name) {
      if (!name) return null;
      if (!this.getVesselsData || !this.getVesselsData.length) return null;
      const row = this.getVesselsData.find(function (v) {
        return v && v.Vessel === name;
      });
      return row || null;
    },

    ensureColors: function () {
      const cols =
        Highcharts.defaultOptions &&
          Highcharts.defaultOptions.colors &&
          Highcharts.defaultOptions.colors.length
          ? Highcharts.defaultOptions.colors.slice()
          : [];
      this.colors = cols.reverse();
    },

    getRangeColor: function (index) {
      if (this.dateRanges && this.dateRanges[index] && this.dateRanges[index].color) {
        return this.dateRanges[index].color;
      }
      const cols =
        Highcharts.defaultOptions &&
          Highcharts.defaultOptions.colors &&
          Highcharts.defaultOptions.colors.length
          ? Highcharts.defaultOptions.colors
          : [];
      if (cols.length) return cols[index % cols.length];
      return undefined;
    },

    saveVesselState: function (vessel) {
      if (!vessel) return;
      this.vesselCache[vessel] = clone({
        dateRanges: this.dateRanges,
        results: this.results,
        histogramData: this.histogramData,
        gridData: this.gridData,
        columns: this.columns,
        parameters: this.parameters,
        vessComp: this.vessComp,
        fdmRequest: this.fdmRequest,
        fdmRequestKey: this.fdmRequestKey,
        seriesMeta: this.seriesMeta
      });

      const keys = Object.keys(this.vesselCache);
      if (keys.length > 10) delete this.vesselCache[keys[0]];
    },

    restoreVesselState: function (vessel) {
      const cached = this.vesselCache[vessel];
      if (!cached) return false;

      this.isRestoring = true;

      this.dateRanges = clone(cached.dateRanges);
      this.results = clone(cached.results);
      this.histogramData = clone(cached.histogramData);
      this.gridData = clone(cached.gridData);
      this.columns = clone(cached.columns);
      this.parameters = clone(cached.parameters);
      this.vessComp = cached.vessComp;
      this.fdmRequest = clone(cached.fdmRequest || []);
      this.fdmRequestKey = cached.fdmRequestKey || "";
      this.seriesMeta = clone(cached.seriesMeta || []);

      this.fetchLoading = false;
      this.calcLoading = false;
      this.disableFetch = true;

      this.isRestoring = false;

      this.histogramRenderKey += 1;
      this.resultsRenderKey += 1;
      this.scheduleReflow();

      return true;
    },

    extractTripletFromStoreItem: function (x) {
      if (!x) return null;

      let vid = null;
      if (typeof x.vesselId !== "undefined" && x.vesselId !== null) vid = x.vesselId;
      else if (typeof x.idVessel !== "undefined" && x.idVessel !== null) vid = x.idVessel;
      else if (typeof x.vessel_id !== "undefined" && x.vessel_id !== null) vid = x.vessel_id;
      else if (x.meta && typeof x.meta.vesselId !== "undefined" && x.meta.vesselId !== null) vid = x.meta.vesselId;

      const sd = toYmd(x.startDate || x.fromDate || x.start_date || (x.meta ? x.meta.startDate : null));
      const ed = toYmd(x.endDate || x.toDate || x.end_date || (x.meta ? x.meta.endDate : null));

      if (vid === null || !sd || !ed) return null;
      return { vesselId: vid, startDate: sd, endDate: ed };
    },

    findFdmStoreEntry: function (req) {
      if (!req) return null;
      const list = (this.localFdmData && this.localFdmData.length)
        ? this.localFdmData
        : (this.getComparisonFDMData || []);

      for (let i = 0; i < list.length; i++) {
        const t = this.extractTripletFromStoreItem(list[i]);
        if (!t) continue;
        if (
          String(t.vesselId) === String(req.vesselId) &&
          String(t.startDate) === String(req.startDate) &&
          String(t.endDate) === String(req.endDate)
        ) {
          return list[i];
        }
      }
      return null;
    },

    initForVessel: async function (vessel) {
      if (!vessel) return;

      if (this.currentVessel && this.currentVessel !== vessel) {
        this.saveVesselState(this.currentVessel);
      }
      this.fdmDataReady = false;

      await this.waitForCondition(function () {
        return this.getVesselsData && this.getVesselsData.length > 0;
      }.bind(this), 15000, 120);

      this.currentVessel = vessel;

      this.sisterVessels = [];
      const baseRow = this.getVesselRowByName(vessel);
      if (baseRow && this.getVesselsData && this.getVesselsData.length) {
        const cls = baseRow.Class;
        this.sisterVessels = this.getVesselsData.filter(function (v) {
          return v && v.Class === cls && v.Vessel !== vessel;
        });
      }

      const hadCache = this.restoreVesselState(vessel);

      if (!hadCache) {
        this.isProgrammaticRangesUpdate = true;
        this.dateRanges = [];
        this.isProgrammaticRangesUpdate = false;
        this.histogramData = {};
        this.results = {};
        this.columns = [];
        this.gridData = [];
        this.fdmRequest = [];
        this.fdmRequestKey = "";
        this.seriesMeta = [];
        this.histogramRenderKey += 1;
        this.resultsRenderKey += 1;
      }

      const s = this.nextSeq();
      this.fetchLoading = true;
      this.calcLoading = true;
      this.disableFetch = true;
      this.first = true;

      try {
        this.fetchComparisonDates(vessel);
        await this.$nextTick();

        const expectedIds = [];
        if (baseRow && baseRow.idVessel) expectedIds.push(baseRow.idVessel);
        if (this.vessComp === "multi" && this.sisterVessels && this.sisterVessels.length) {
          for (let si = 0; si < this.sisterVessels.length; si++) {
            if (this.sisterVessels[si] && this.sisterVessels[si].idVessel) {
              expectedIds.push(this.sisterVessels[si].idVessel);
            }
          }
        }

        const okDates = await this.waitForCondition(function () {
          if (!this.getComparisonDates || !this.getComparisonDates.length) return false;
          if (!expectedIds.length) return this.getComparisonDates.length > 0;

          for (let i = 0; i < expectedIds.length; i++) {
            const found = this.getComparisonDates.find(function (x) {
              return x && String(x.vesselId) === String(expectedIds[i]);
            });
            if (!found) return false;
          }
          return true;
        }.bind(this), 9000, 140);

        if (!okDates || !this.isSeqCurrent(s)) return;

        this.rebuildRangesFromDates(true);

        await this.fetchFDMDataInternal(s);
        if (!this.isSeqCurrent(s)) return;

        this.setChartDataInternal(s);
        if (!this.isSeqCurrent(s)) return;

        if (this.first) {
          this.first = false;
          await this.calculateInternal(s);
        }
      } finally {
        if (this.isSeqCurrent(s)) {
          this.fetchLoading = false;
        }
      }
    },

    rebuildRangesFromDates: function () {
      const vessel = this.currentVessel;
      if (!vessel) return;
      if (!this.getVesselsData || !this.getVesselsData.length) return;
      if (!this.getComparisonDates || !this.getComparisonDates.length) return;

      const baseRow = this.getVesselRowByName(vessel);
      if (!baseRow) return;

      const dBase = this.getComparisonDates.find(function (x) {
        return x && String(x.vesselId) === String(baseRow.idVessel);
      });
      if (!dBase) return;

      this.ensureColors();

      const maxBase = toYmd(dBase.maxdate);
      const minBase = toYmd(dBase.mindate);

      const endBase = maxBase;
      let startBase = null;
      if (maxBase) {
        const dStart = new Date(maxBase + "T00:00:00Z");
        dStart.setUTCMonth(dStart.getUTCMonth() - 1);
        startBase = dStart.toISOString().substring(0, 10);
      }

      const baseClr = this.colors.length ? this.colors.pop() : undefined;

      const baseRange = {
        dateMenu: false,
        startDate: startBase,
        endDate: endBase,
        minDate: minBase,
        maxDate: maxBase,
        dateText: startBase && endBase ? "From " + startBase + " to " + endBase : "",
        color: baseClr,
        vessel: vessel,
        vesselId: baseRow.idVessel,
        checked: true
      };

      const ranges = [baseRange];

      if (this.vessComp === "multi") {
        const sisters = this.sisterVessels || [];
        for (let i = 0; i < sisters.length; i++) {
          const srow = sisters[i];
          if (!srow) continue;

          const ds = this.getComparisonDates.find(function (x) {
            return x && String(x.vesselId) === String(srow.idVessel);
          });
          if (!ds) continue;

          const maxS = toYmd(ds.maxdate);
          const minS = toYmd(ds.mindate);

          const endS = maxS;
          let startS = null;
          if (maxS) {
            const dS = new Date(maxS + "T00:00:00Z");
            dS.setUTCMonth(dS.getUTCMonth() - 1);
            startS = dS.toISOString().substring(0, 10);
          }

          ranges.push({
            dateMenu: false,
            startDate: startS,
            endDate: endS,
            minDate: minS,
            maxDate: maxS,
            dateText: startS && endS ? "From " + startS + " to " + endS : "",
            color: this.colors.length ? this.colors.pop() : undefined,
            vessel: srow.Vessel,
            vesselId: srow.idVessel,
            checked: false
          });
        }
      }

      this.isProgrammaticRangesUpdate = true;
      this.dateRanges = ranges;
      this.isProgrammaticRangesUpdate = false;

      this.disableFetch = true;
    },

    updateDataTableHeight: function () {
      if (!this.$refs || !this.$refs.parentDiv) return;
      const el = this.$refs.parentDiv.$el ? this.$refs.parentDiv.$el : this.$refs.parentDiv;
      if (!el || !el.clientHeight) return;
      this.dataTableHeight = el.clientHeight;
    },

    calcMaxDate: function (range) {
      if (!range) return null;
      if (range.endDate === null) return range.maxDate;
      return range.endDate;
    },

    calcMinDate: function (range) {
      if (!range) return null;
      if (range.startDate === null) return range.minDate;
      return range.startDate;
    },

    fetchFDMData: async function () {
      const s = this.nextSeq();
      this.fetchLoading = true;
      this.disableFetch = true;
      this.fdmDataReady = false;

      await this.fetchFDMDataInternal(s);
      if (!this.isSeqCurrent(s)) return;

      this.setChartDataInternal(s);
      this.fetchLoading = false;
    },

    fetchFDMDataInternal: async function (s) {
      if (!this.isSeqCurrent(s)) return;

      const vessel = this.currentVessel;
      if (!vessel) return;

      const baseRow = this.getVesselRowByName(vessel);
      if (!baseRow) return;

      const postForFDMData = [];
      const meta = [];

      if (this.vessComp === "single") {
        for (let i = 0; i < this.dateRanges.length; i++) {
          const r = this.dateRanges[i];
          if (!r || !r.startDate || !r.endDate) continue;

          postForFDMData.push({
            vesselId: baseRow.idVessel,
            startDate: r.startDate,
            endDate: r.endDate
          });

          meta.push({
            vesselId: baseRow.idVessel,
            startDate: r.startDate,
            endDate: r.endDate,
            color: r.color,
            label: r.dateText || ("From " + r.startDate + " to " + r.endDate),
            rangeIndex: i
          });
        }
      } else {
        for (let j = 0; j < this.dateRanges.length; j++) {
          const rr = this.dateRanges[j];
          if (!rr || !rr.checked) continue;
          if (!rr.vesselId || !rr.startDate || !rr.endDate) continue;

          postForFDMData.push({
            vesselId: rr.vesselId,
            startDate: rr.startDate,
            endDate: rr.endDate
          });

          meta.push({
            vesselId: rr.vesselId,
            startDate: rr.startDate,
            endDate: rr.endDate,
            color: rr.color,
            label: rr.vessel || ("Vessel " + String(rr.vesselId)),
            rangeIndex: j
          });
        }
      }

      if (!postForFDMData.length) return;

      this.fdmRequest = clone(postForFDMData);
      this.fdmRequestKey = buildReqKey(postForFDMData);
      this.seriesMeta = meta;

      this.localFdmData = [];

      let fdmResponse = null;
      try {
        fdmResponse = await this.fetchComparisonFDMData({
          vessel: vessel,
          data: postForFDMData
        });
      } catch (e) {
        return;
      }

      if (fdmResponse && Array.isArray(fdmResponse)) {
        this.localFdmData = fdmResponse;
      }

      await this.waitForCondition(function () {
        const req = this.fdmRequest || [];
        if (!req.length) return false;
        if (!this.fdmRequestKey) return false;

        let m = 0;
        for (let k = 0; k < req.length; k++) {
          const hit = this.findFdmStoreEntry(req[k]);
          if (hit && hit.fdmData && hit.fdmData.length >= 0) m += 1;
        }
        return m === req.length;
      }.bind(this), 25000, 140);

      await this.$nextTick();
      if (!this.isSeqCurrent(s)) return;

      this.fdmDataReady = true;
    },

    setChartDataInternal: function (s) {
      if (!this.isSeqCurrent(s)) return;

      const filteredData = this.filterData();
      const newHistogramData = {};

      for (let i = 0; i < this.parameters.length; i++) {
        const param = this.parameters[i];
        const tag = param.tag;
        const labelsVisible = i === 0;
        const yTitle = i === 0 ? "Frequency [%]" : null;
        const bucketCfg = this.getBucketConfig(tag);

        const chartOptions = {
          credits: { enabled: false },
          time: { useUTC: true },
          chart: {
            zoomType: null,
            panning: false,
            pinchType: null,
            events: {
              selection: function () { return false; }
            }
          },
          title: { text: null },
          tooltip: {
            formatter: function () {
              const symbol = "●";
              let xLabel = this.x;

              if (tag === "ME_Power") {
                const rounded = Math.round(this.x);
                if (Math.abs(rounded) >= 1000) {
                  const kValue = rounded / 1000;
                  xLabel = Number.isInteger(kValue) ? (kValue + "k") : (kValue.toFixed(1) + "k");
                } else {
                  xLabel = rounded;
                }
              }

              return this.points.reduce(function (s2, point) {
                return (
                  s2 +
                  "<br/><span style=\"color:" +
                  point.series.color +
                  "\">" +
                  symbol +
                  "</span> " +
                  point.y.toFixed(1) +
                  " %"
                );
              }, "<b>" + this.points[0].series.name + " " + xLabel + "</b>");
            },
            shared: true
          },
          yAxis: {
            min: 0,
            max: 100,
            gridLineWidth: 2,
            title: {
              text: yTitle,
              align: "high",
              style: { fontSize: "14px" }
            },
            labels: {
              enabled: labelsVisible,
              style: { fontSize: "12px" }
            }
          },
          xAxis: {
            startOnTick: true,
            endOnTick: true,
            labels: {
              style: { fontSize: "9px" },
              formatter: function () {
                if (tag === "ME_Power") {
                  const value = Number(this.value);
                  if (Math.abs(value) >= 1000) {
                    const kValue = value / 1000;
                    return Number.isInteger(kValue) ? (kValue + "k") : (kValue.toFixed(1) + "k");
                  }
                  return Math.round(value);
                }
                return this.value;
              }
            },
            crosshair: true,
            title: {
              text: param.name + " [" + param.unit + "]",
              align: "high",
              style: { fontSize: "14px" }
            }
          },
          exporting: { enabled: false },
          legend: { enabled: false },
          series: []
        };

        const allParam = filteredData
          .reduce(function (acc, curr) { return acc.concat(curr); }, [])
          .map(function (item) {
            const val = safeNumber(item[tag]);
            if (val === null) return null;
            return tag === "ME_Power" ? this.roundToNearest(val, 10) : val;
          }.bind(this))
          .filter(function (x) { return x !== null; })
          .filter(function (x) {
            if (tag === "LOG_Speed") return x >= 6;
            return true;
          });

        if (!allParam.length) {
          newHistogramData[tag] = chartOptions;
          continue;
        }

        const max = this.getMax(allParam);
        const min = this.getMin(allParam);

        if (bucketCfg) {
          const step = bucketCfg.step;

          const bucketValues = allParam
            .map((x) => this.roundToStep(x, step))
            .filter((x) => x !== null)
            .sort((a, b) => a - b)
            .filter((x, index, arr) => index === 0 || x !== arr[index - 1]);

          const categories = bucketValues.map((v) => this.formatBucketLabel(v, bucketCfg.decimals));

          chartOptions.xAxis = {
            categories: categories,
            crosshair: true,
            labels: {
              style: { fontSize: "8px" },
              autoRotation: false,
              reserveSpace: true,
              formatter: function () {
                const label = this.axis.categories[this.pos];
                const num = Number(String(label).replace(",", "."));
                if (Number.isNaN(num)) return label;

                if (tag === "Mean_Draft" || tag === "Trim") {
                  return Number.isInteger(num) ? String(num) : "";
                }

                return label;
              }
            },
            title: {
              text: param.name + " [" + param.unit + "]",
              align: "high",
              style: { fontSize: "14px" }
            }
          };

          chartOptions.tooltip = {
            formatter: function () {
              const symbol = "●";
              return this.points.reduce(function (s2, point) {
                return (
                  s2 +
                  "<br/><span style=\"color:" +
                  point.series.color +
                  "\">" +
                  symbol +
                  "</span> " +
                  point.y.toFixed(1) +
                  " %"
                );
              }, "<b>" + this.x + "</b>");
            },
            shared: true
          };

          for (let j = 0; j < filteredData.length; j++) {
            const tempDataDiscrete = filteredData[j]
              .map(function (item) { return safeNumber(item[tag]); })
              .filter(function (x) { return x !== null; });

            if (!tempDataDiscrete.length) continue;

            const seriesDiscrete = {
              name: this.getSeriesLabel(j),
              type: "column",
              color: this.getSeriesColor(j),
              data: [],
              marker: { enabled: false },
              animation: false,
              states: {
                hover: { enabled: false },
                normal: { animation: false },
                inactive: { opacity: 1 }
              }
            };

            const totalDiscrete = tempDataDiscrete.length;
            const normalizedData = tempDataDiscrete.map(function (x) {
              return this.roundToStep(x, step);
            }.bind(this));

            for (let b = 0; b < bucketValues.length; b++) {
              const bucketVal = bucketValues[b];
              const count = normalizedData.filter(function (x) {
                return x === bucketVal;
              }).length;

              seriesDiscrete.data.push((count / totalDiscrete) * 100);
            }

            chartOptions.series.push(seriesDiscrete);
          }

          newHistogramData[tag] = chartOptions;
          continue;
        }

        const range = max - min;
        const binCount = this.getBinsForTag(tag);
        const stepCont = range === 0 ? 1 : range / binCount;

        if (tag === "ME_Power") {
          chartOptions.xAxis.minPadding = 0;
          chartOptions.xAxis.maxPadding = 0;
          chartOptions.xAxis.startOnTick = false;
          chartOptions.xAxis.endOnTick = false;
          chartOptions.xAxis.tickInterval = 1500;

          let firstShownX = null;
          let lastShownX = null;

          for (let kk = 0; kk < filteredData.length; kk++) {
            const tempDataForRange = filteredData[kk]
              .map(function (item) {
                const val = safeNumber(item[tag]);
                if (val === null) return null;
                return tag === "ME_Power" ? this.roundToNearest(val, 10) : val;
              }.bind(this))
              .filter(function (x) { return x !== null; });

            if (!tempDataForRange.length) continue;

            const totalForRange = tempDataForRange.length;

            for (let c = 0; c < binCount; c++) {
              const binMin = min + c * stepCont;
              const binMax = binMin + stepCont;

              const inst = tempDataForRange.filter(function (x) {
                return c === binCount - 1
                  ? x >= binMin && x <= binMax
                  : x >= binMin && x < binMax;
              }).length;

              const pct = (inst / totalForRange) * 100;

              if (pct > 0.5) {
                const xMid = binMin + stepCont / 2;
                if (firstShownX === null) firstShownX = xMid;
                lastShownX = xMid;
              }
            }
          }

          if (firstShownX !== null && lastShownX !== null) {
            chartOptions.xAxis.min = firstShownX - stepCont / 2;
            chartOptions.xAxis.max = lastShownX + stepCont / 2;
          } else if (range === 0) {
            chartOptions.xAxis.min = min - 5;
            chartOptions.xAxis.max = max + 5;
          } else {
            chartOptions.xAxis.min = min;
            chartOptions.xAxis.max = max;
          }
        } else {
          chartOptions.xAxis.min = min;
          chartOptions.xAxis.max = max;
        }

        for (let k = 0; k < filteredData.length; k++) {
          const tempData = filteredData[k]
            .filter(function (item) {
              const stw = safeNumber(item.LOG_Speed);
              return stw === null || stw >= 6;
            })
            .map(function (item) {
              const val = safeNumber(item[tag]);
              if (val === null) return null;
              return tag === "ME_Power" ? this.roundToNearest(val, 10) : val;
            }.bind(this))
            .filter(function (x) { return x !== null; });

          if (!tempData.length) continue;

          const series = {
            name: this.getSeriesLabel(k),
            type: "column",
            color: this.getSeriesColor(k),
            data: [],
            marker: { enabled: false },
            animation: false,
            states: {
              hover: { enabled: false },
              normal: { animation: false },
              inactive: { opacity: 1 }
            }
          };

          const total = tempData.length;

          if (range === 0) {
            series.data.push({ x: min, y: 100 });
            chartOptions.series.push(series);
            continue;
          }

          for (let c = 0; c < binCount; c++) {
            const binMin = min + c * stepCont;
            const binMax = binMin + stepCont;

            const inst = tempData.filter(function (x) {
              return c === binCount - 1
                ? x >= binMin && x <= binMax
                : x >= binMin && x < binMax;
            }).length;

            const val = binMin + stepCont / 2;
            const pct = (inst / total) * 100;

            if (pct > 0.5) {
              series.data.push({ x: val, y: pct });
            }
          }

          chartOptions.series.push(series);
        }

        newHistogramData[tag] = chartOptions;
      }

      this.$nextTick(() => {
        this.histogramData = newHistogramData;
        this.histogramRenderKey += 1;
      });

      this.scheduleReflow();
      if (this.currentVessel) this.saveVesselState(this.currentVessel);
    },

    filterData: function () {
      const filteredData = [];
      const req = this.fdmRequest || [];
      if (!req.length) return filteredData;

      for (let r = 0; r < req.length; r++) {
        const storeEntry = this.findFdmStoreEntry(req[r]);
        let tempData = storeEntry && storeEntry.fdmData ? storeEntry.fdmData.slice() : [];

        for (let i = 0; i < this.parameters.length; i++) {
          if (!("value" in this.parameters[i])) continue;

          const tag = this.parameters[i].tag;
          const rawValue = this.parameters[i].value;
          const selectedValue = safeNumber(rawValue);

          if (rawValue === "" || rawValue === null || typeof rawValue === "undefined" || selectedValue === null) {
            continue;
          }

          const bucketCfg = this.getBucketConfig(tag);

          if (bucketCfg) {
            if (tag === "Mean_Draft" || tag === "Trim") {
              tempData = tempData.filter(function (item) {
                const v = safeNumber(item[tag]);
                if (v === null) return false;
                return Math.abs(v - selectedValue) <= 1;
              });
              continue;
            }

            const step = bucketCfg.step;
            const normalizedSelected = this.roundToStep(selectedValue, step);

            tempData = tempData.filter(function (item) {
              const v = safeNumber(item[tag]);
              if (v === null) return false;
              return this.roundToStep(v, step) === normalizedSelected;
            }.bind(this));

            continue;
          }

          tempData = tempData.filter(function (item) {
            const v = safeNumber(item[tag]);
            return v !== null && v === selectedValue;
          });
        }

        filteredData.push(tempData);
      }

      return filteredData;
    },

    updateDateRanges: function (range) {
      if (range && range.startDate !== null && range.endDate !== null) {
        range.startDate = toYmd(range.startDate);
        range.endDate = toYmd(range.endDate);
        range.dateText = "From " + range.startDate + " to " + range.endDate;
      }
      if (range) range.dateMenu = false;
      this.disableFetch = false;
    },

    addDateRange: function () {
      if (!this.colors || !this.colors.length) this.ensureColors();
      const clr = this.colors.length ? this.colors.pop() : undefined;

      const base = this.dateRanges && this.dateRanges.length
        ? this.dateRanges[this.dateRanges.length - 1]
        : null;

      this.dateRanges.splice(0, 0, {
        dateMenu: true,
        startDate: null,
        endDate: null,
        minDate: base ? base.minDate : null,
        maxDate: base ? base.maxDate : null,
        color: clr,
        dateText: ""
      });
      this.disableFetch = false;
    },

    deleteDateRange: function (index) {
      if (this.dateRanges[index] && this.dateRanges[index].color) {
        this.colors.push(this.dateRanges[index].color);
      }
      this.dateRanges.splice(index, 1);
      this.disableFetch = false;
    },

    calcRange: function (range) {
      const selArray = [];
      if (!range || !range.startDate || !range.endDate) return selArray;

      const currentDate = new Date(range.startDate + "T00:00:00Z");
      const endDate = new Date(range.endDate + "T00:00:00Z");

      while (currentDate < endDate) {
        currentDate.setUTCDate(currentDate.getUTCDate() + 1);
        selArray.push(new Date(currentDate).toISOString().substring(0, 10));
      }

      selArray.pop();
      return selArray;
    },

    getMax: function (arr) {
      let len = arr.length;
      let max = -Infinity;
      while (len--) max = arr[len] > max ? arr[len] : max;
      return max;
    },

    getMin: function (arr) {
      let len = arr.length;
      let min = Infinity;
      while (len--) min = arr[len] < min ? arr[len] : min;
      return min;
    },

    hexToRgb: function (hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }
        : null;
    },

    calculate: async function () {
      const s = this.nextSeq();
      this.calcLoading = true;
      await this.calculateInternal(s);
    },

    calculateInternal: async function (s) {
      if (!this.isSeqCurrent(s)) return;

      const vessel = this.currentVessel;
      if (!vessel) return;

      const baseRow = this.getVesselRowByName(vessel);
      if (!baseRow) {
        this.clearCalculationResults();
        this.calcLoading = false;
        return;
      }

      const dataForPy = {
        ids: [],
        fromDate: [],
        toDate: [],
        draft: [],
        trim: [],
        wind: [],
        wind_dir: []
      };

      const values = {};
      this.parameters.forEach(function (item) {
        const num = safeNumber(item.value);
        values[item.tag] = num === null ? "None" : num;
      });

      if (this.vessComp === "single") {
        for (let i = 0; i < this.dateRanges.length; i++) {
          const r = this.dateRanges[i];
          if (!r || !r.startDate || !r.endDate) continue;
          dataForPy.ids.push(baseRow.idVessel);
          dataForPy.fromDate.push(r.startDate);
          dataForPy.toDate.push(r.endDate);
          dataForPy.draft.push(values.Mean_Draft);
          dataForPy.trim.push(values.Trim);
          dataForPy.wind.push(values.bft_scale);
          dataForPy.wind_dir.push("None");
        }
      } else {
        for (let j = 0; j < this.dateRanges.length; j++) {
          const rr = this.dateRanges[j];
          if (!rr || !rr.checked) continue;
          if (!rr.vesselId || !rr.startDate || !rr.endDate) continue;
          dataForPy.ids.push(rr.vesselId);
          dataForPy.fromDate.push(rr.startDate);
          dataForPy.toDate.push(rr.endDate);
          dataForPy.draft.push(values.Mean_Draft);
          dataForPy.trim.push(values.Trim);
          dataForPy.wind.push(values.bft_scale);
          dataForPy.wind_dir.push("None");
        }
      }

      if (!dataForPy.ids.length) {
        this.clearCalculationResults();
        this.calcLoading = false;
        return;
      }

      let payload = null;

      try {
        payload = await this.fetchComparisonPower({
          vessel: vessel,
          postData: dataForPy
        });
      } catch (e) {
        this.clearCalculationResults();
        this.calcLoading = false;
        return;
      }

      if (!this.isSeqCurrent(s)) {
        this.calcLoading = false;
        return;
      }

      if (!payload || !payload.dataForVessels || !payload.periodDiffs) {
        this.clearCalculationResults();
        this.calcLoading = false;
        return;
      }

      const filteredData = this.filterData();
      const hasFilteredData = filteredData.some(function (arr) {
        return arr && arr.length;
      });

      if (!hasFilteredData) {
        this.clearCalculationResults();
        this.calcLoading = false;
        return;
      }

      const data = payload.dataForVessels;
      const newResults = {};

      const resultParameters = [
        { tag: "power", xAxis: "STW [kn]", yAxis: "ME Power [kW]" },
        { tag: "powerDiff", xAxis: "STW [kn]", yAxis: "Power - Reference Comparison [%]" }
      ];

      resultParameters.forEach(function (param) {
        newResults[param.tag] = {
          credits: { enabled: false },
          time: { useUTC: true },
          chart: { zoomType: "xy" },
          title: { text: null },
          tooltip: {
            formatter: function () {
              const symbol = "●";
              return this.points.reduce(function (s2, point) {
                return (
                  s2 +
                  "<br/><span style=\"color:" +
                  point.series.color +
                  "\">" +
                  symbol +
                  "</span> " +
                  point.y.toFixed(1)
                );
              }, "<b>" + this.x.toFixed(0) + " kn</b>");
            },
            shared: true
          },
          yAxis: {
            gridLineWidth: 2,
            title: {
              text: param.yAxis,
              align: "high",
              style: { fontSize: "14px" }
            },
            labels: { style: { fontSize: "12px" } }
          },
          xAxis: {
            title: {
              text: param.xAxis,
              align: "high",
              style: { fontSize: "14px" }
            },
            labels: { style: { fontSize: "12px" } },
            crosshair: true
          },
          exporting: { enabled: false },
          legend: { enabled: false },
          series: []
        };
      });

      data.forEach(function (item, index) {
        let ser = {
          type: "column",
          data: [],
          color: this.getSeriesColor(index),
          marker: { enabled: false },
          animation: false,
          states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } }
        };

        let stwKeys = Object.keys(item.fdm_diffs_per_knot || {})
          .filter(function (k) { return Number(k) >= 6; });
        for (let i = 0; i < stwKeys.length; i++) {
          const k = stwKeys[i];
          ser.data.push({
            x: Number(k),
            y: item.fdm_diffs_per_knot[k].median_fdm_power
          });
        }
        newResults.power.series.push(ser);

        ser = {
          type: "column",
          data: [],
          color: this.getSeriesColor(index),
          marker: { enabled: false },
          animation: false,
          states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } }
        };

        stwKeys = Object.keys(item.model_diffs_per_knot || {});
        for (let j = 0; j < stwKeys.length; j++) {
          const kk = stwKeys[j];
          ser.data.push({
            x: Number(kk),
            y: item.model_diffs_per_knot[kk].median_power_diff_pct
          });
        }
        newResults.powerDiff.series.push(ser);
      }.bind(this));

      newResults.powerRPM = {
        credits: { enabled: false },
        time: { useUTC: true },
        chart: { zoomType: "xy" },
        title: { text: null },
        tooltip: {
          formatter: function () {
            const symbol = "●";
            return this.points.reduce(function (s2, point) {
              return (
                s2 +
                "<br/><span style=\"color:" +
                point.series.color +
                "\">" +
                symbol +
                "</span> " +
                point.y.toFixed(0)
              );
            }, "<b>" + this.x.toFixed(1) + " rpm</b>");
          },
          shared: true
        },
        yAxis: {
          gridLineWidth: 2,
          title: { text: "ME Power [kW]", align: "high", style: { fontSize: "14px" } },
          labels: { style: { fontSize: "12px" } }
        },
        xAxis: {
          title: { text: "Engine Speed [RPM]", align: "high", style: { fontSize: "14px" } },
          labels: { style: { fontSize: "12px" } },
          crosshair: true
        },
        exporting: { enabled: false },
        legend: { enabled: false },
        series: []
      };

      newResults.stwRPM = {
        credits: { enabled: false },
        time: { useUTC: true },
        chart: { zoomType: "xy" },
        title: { text: null },
        tooltip: {
          formatter: function () {
            const symbol = "●";
            return this.points.reduce(function (s2, point) {
              return (
                s2 +
                "<br/><span style=\"color:" +
                point.series.color +
                "\">" +
                symbol +
                "</span> " +
                point.y.toFixed(0)
              );
            }, "<b>" + this.x.toFixed(1) + " rpm</b>");
          },
          shared: true
        },
        yAxis: {
          gridLineWidth: 2,
          reversed: true,
          title: { text: "STW [kn]", align: "high", style: { fontSize: "14px" } },
          labels: { style: { fontSize: "12px" } }
        },
        xAxis: {
          visible: false,
          title: { text: "Engine Speed [RPM]", align: "high", style: { fontSize: "14px" } },
          labels: { style: { fontSize: "12px" } },
          crosshair: true
        },
        exporting: { enabled: false },
        legend: { enabled: false },
        series: []
      };

      newResults.powerStw = {
        credits: { enabled: false },
        time: { useUTC: true },
        chart: { zoomType: "xy" },
        title: { text: null },
        tooltip: {
          formatter: function () {
            const symbol = "●";
            return this.points.reduce(function (s2, point) {
              return (
                s2 +
                "<br/><span style=\"color:" +
                point.series.color +
                "\">" +
                symbol +
                "</span> " +
                point.y.toFixed(0)
              );
            }, "<b>" + this.x.toFixed(1) + " stw</b>");
          },
          shared: true
        },
        yAxis: {
          gridLineWidth: 2,
          title: { text: "ME Power [kW]", align: "high", style: { fontSize: "14px" } },
          labels: { style: { fontSize: "12px" } }
        },
        xAxis: {
          title: { text: "STW [kn]", align: "high", style: { fontSize: "14px" } },
          labels: { style: { fontSize: "12px" } },
          crosshair: true
        },
        exporting: { enabled: false },
        legend: { enabled: false },
        series: []
      };

      if (this.isCompany5) {
        newResults.consumptionPower = {
          credits: { enabled: false },
          time: { useUTC: true },
          chart: { zoomType: "xy" },
          title: { text: null },
          tooltip: {
            formatter: function () {
              const symbol = "●";
              return this.points.reduce(function (s2, point) {
                return (
                  s2 +
                  "<br/><span style=\"color:" +
                  point.series.color +
                  "\">" +
                  symbol +
                  "</span> " +
                  point.y.toFixed(2)
                );
              }, "<b>Power: " + this.x.toFixed(0) + " kW</b>");
            },
            shared: true
          },
          yAxis: {
            gridLineWidth: 2,
            title: { text: "Fuel Oil Consumption [t/day]", align: "high", style: { fontSize: "14px" } },
            labels: { style: { fontSize: "12px" } }
          },
          xAxis: {
            title: { text: "ME Power [kW]", align: "high", style: { fontSize: "14px" } },
            labels: { style: { fontSize: "12px" } },
            crosshair: true
          },
          exporting: { enabled: false },
          legend: { enabled: false },
          series: []
        };
      }

      filteredData.forEach(function (arr, index) {
        const baseColor = this.getSeriesColor(index);
        const rgbColor = baseColor ? this.hexToRgb(baseColor) : null;
        const rgba = rgbColor
          ? "rgba(" + rgbColor.r + "," + rgbColor.g + "," + rgbColor.b + ",0.1)"
          : "rgba(0,0,0,0.1)";

        // Scatter series shells
        const power = {
          type: "scatter",
          data: [],
          marker: { enabled: true, symbol: "circle", radius: 3, fillColor: rgba },
          animation: false,
          turboThreshold: 5000,
          boostThreshold: 2000,
          enableMouseTracking: false,
          states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } }
        };

        const stw = {
          type: "scatter",
          data: [],
          marker: { enabled: true, symbol: "circle", radius: 3, fillColor: rgba },
          animation: false,
          turboThreshold: 5000,
          boostThreshold: 2000,
          enableMouseTracking: false,
          states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } }
        };

        const powerSpeed = {
          type: "scatter",
          data: [],
          marker: { enabled: true, symbol: "circle", radius: 3, fillColor: rgba },
          animation: false,
          turboThreshold: 5000,
          boostThreshold: 2000,
          enableMouseTracking: false,
          states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } }
        };

        const powerLinear = {
          type: "line",
          color: baseColor,
          data: [],
          marker: { enabled: false },
          animation: false,
          states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } },
          lineWidth: 3
        };

        const stwLinear = {
          type: "line",
          color: baseColor,
          data: [],
          marker: { enabled: false },
          animation: false,
          states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } },
          lineWidth: 3
        };

        const powerSpeedLinear = {
          type: "line",
          color: baseColor,
          data: [],
          marker: { enabled: false },
          animation: false,
          states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } },
          lineWidth: 3
        };

        // ===== Collect RAW points first (NOT pushing to series yet) =====
        const rawPower = [];           // [rpm, ME_Power]
        const rawStw = [];             // [rpm, LOG_Speed]
        const rawPowerSpeed = [];      // [LOG_Speed, ME_Power]
        const rawConsumption = [];     // [ME_Power, FOC (t/day)]
        const xValues = [];
        const powerSpeedXValues = [];

        arr.forEach(function (inst) {
          if (inst.LOG_Speed < 6) return;

          const rpmVal = Math.round((inst.ME_RPM + Number.EPSILON) * 10) / 10;
          rawPower.push([rpmVal, inst.ME_Power]);
          rawStw.push([rpmVal, inst.LOG_Speed]);
          rawPowerSpeed.push([inst.LOG_Speed, inst.ME_Power]);

          if (this.isCompany5) {
            const tph = safeNumber(inst.ME_Fuel_Mass_Supply_tph);
            const pw = safeNumber(inst.ME_Power);
            if (tph !== null && pw !== null) {
              rawConsumption.push([pw, tph * 24]);
            }
          }

          xValues.push(rpmVal);
          powerSpeedXValues.push(inst.LOG_Speed);
        }.bind(this));

        if (!xValues.length || !powerSpeedXValues.length) return;

        // ===== OPTIMIZE: Deduplicate + Downsample =====
        const prec = this.scatterPrecision;

        power.data = this.optimizeScatterData(rawPower, prec.rpm, prec.power);
        stw.data = this.optimizeScatterData(rawStw, prec.rpm, prec.speed);
        powerSpeed.data = this.optimizeScatterData(rawPowerSpeed, prec.speed, prec.power);

        // ===== Build trend lines (small, no optimization needed) =====
        const minRPM = this.getMin(xValues);
        const maxRPM = this.getMax(xValues);
        const rpmStep = 0.1;
        let xVal = Math.round((minRPM + Number.EPSILON) * 10) / 10;

        const minSpeed = this.getMin(powerSpeedXValues);
        const maxSpeed = this.getMax(powerSpeedXValues);
        const speedStep = 0.1;
        let speedVal = Math.round((minSpeed + Number.EPSILON) * 10) / 10;

        const ab = data[index] && data[index].a_b_parameters ? data[index].a_b_parameters : null;
        if (!ab) return;

        const aPower = ab.RPM_Power.a_parameter;
        const bPower = ab.RPM_Power.b_parameter;

        const aSTW = ab.STW_RPM.a_parameter;
        const bSTW = ab.STW_RPM.b_parameter;

        const aPowerSpeed = ab.STW_Power.a_parameter;
        const bPowerSpeed = ab.STW_Power.b_parameter;

        while (xVal <= maxRPM) {
          powerLinear.data.push([xVal, aPower * Math.pow(xVal, bPower)]);
          stwLinear.data.push([xVal, aSTW * Math.pow(xVal, bSTW)]);
          xVal += rpmStep;
        }

        while (speedVal <= maxSpeed) {
          powerSpeedLinear.data.push([speedVal, aPowerSpeed * Math.pow(speedVal, bPowerSpeed)]);
          speedVal += speedStep;
        }

        newResults.powerRPM.series.push(power);
        newResults.stwRPM.series.push(stw);
        newResults.powerRPM.series.push(powerLinear);
        newResults.stwRPM.series.push(stwLinear);
        newResults.powerStw.series.push(powerSpeed);
        newResults.powerStw.series.push(powerSpeedLinear);

        // ===== Consumption Power Series (vendor spline + measured scatter) =====
        if (this.isCompany5 && newResults.consumptionPower) {
          const consumptionScatter = {
            type: "scatter",
            name: this.getSeriesLabel(index),
            data: this.optimizeScatterData(rawConsumption),
            marker: { enabled: true, symbol: "circle", radius: 3, fillColor: rgba },
            animation: false,
            turboThreshold: 5000,
            boostThreshold: 2000,
            enableMouseTracking: false,
            states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } }
          };

          const vendorCurve = {
            type: "spline",
            name: this.getSeriesLabel(index) + " (reference)",
            color: baseColor,
            data: [],
            marker: { enabled: false },
            animation: false,
            states: { hover: { enabled: false }, normal: { animation: false }, inactive: { opacity: 1 } },
            lineWidth: 3
          };

          const vd = data[index] && data[index].vessel_data ? data[index].vessel_data : null;
          if (vd && Array.isArray(vd.power_for_graph) && Array.isArray(vd.daily_foc_for_graph)) {
            const n = Math.min(vd.power_for_graph.length, vd.daily_foc_for_graph.length);
            for (let vi = 0; vi < n; vi++) {
              const pxRaw = vd.power_for_graph[vi];
              const pyRaw = vd.daily_foc_for_graph[vi];
              const px = safeNumber(Array.isArray(pxRaw) ? pxRaw[0] : pxRaw);
              const py = safeNumber(Array.isArray(pyRaw) ? pyRaw[0] : pyRaw);
              if (px !== null && py !== null) vendorCurve.data.push([px, py]);
            }
            vendorCurve.data.sort(function (a, b) { return a[0] - b[0]; });
          }

          if (rawConsumption.length > 0) {
            newResults.consumptionPower.series.push(consumptionScatter);
          }
          if (vendorCurve.data.length > 0) {
            newResults.consumptionPower.series.push(vendorCurve);
          }
        }
      }.bind(this));

      const diffData = payload.periodDiffs;
      const keys = Object.keys(diffData);
      const compTitle = this.vessComp === "single" ? "Period " : "Vessel ";
      let newColumns;

      if (defaultViewSettings.showAverageMeassured) {
        newColumns = [
          { text: compTitle + "1", align: "start", sortable: true, value: "value1", class: "tableHeader bodyText" },
          { text: compTitle + "2", align: "start", sortable: true, value: "value2", class: "tableHeader bodyText" },
          { text: "STW [kn]", align: "start", sortable: true, value: "stw", class: "tableHeader bodyText" },
          { text: "Power Difference [kW]", align: "start", sortable: true, value: "powerDiff", class: "tableHeader bodyText" },
          { text: "Foc difference [t/day]", align: "start", sortable: true, value: "focDiff", class: "tableHeader bodyText" }
        ];
        newColumns.push(
          { text: "Avg Measured Power Diff [kW]", align: "start", sortable: true, value: "avgPowerDiff", class: "tableHeader bodyText" },
          { text: "Avg Measured FOC Diff [t/day]", align: "start", sortable: true, value: "avgFocDiff", class: "tableHeader bodyText" }
        );
      }
      else if (!defaultViewSettings.showAverageMeassured) {
        newColumns = [
          { text: compTitle + "1", align: "start", sortable: true, value: "value1", class: "tableHeader bodyText" },
          { text: compTitle + "2", align: "start", sortable: true, value: "value2", class: "tableHeader bodyText" },
          { text: "STW [kn]", align: "start", sortable: true, value: "stw", class: "tableHeader bodyText" },
          { text: "Power Difference [kW]", align: "start", sortable: true, value: "powerDiff2", class: "tableHeader bodyText" },
          { text: "Foc difference [t/day]", align: "start", sortable: true, value: "focDiff2", class: "tableHeader bodyText" }
        ];
      }

      const newGridData = [];

      keys.forEach(function (key) {
        let value1 = "";
        let value2 = "";
        const indexes = key.split("-").map(function (x) { return Number(x); });

        if (this.vessComp === "single") {
          value1 = this.dateRanges[indexes[0]] ? this.dateRanges[indexes[0]].dateText : "";
          value2 = this.dateRanges[indexes[1]] ? this.dateRanges[indexes[1]].dateText : "";
        } else {
          value1 = this.seriesMeta[indexes[0]] ? this.seriesMeta[indexes[0]].label : "";
          value2 = this.seriesMeta[indexes[1]] ? this.seriesMeta[indexes[1]].label : "";
        }

        const allSTW = Object.keys(diffData[key].fdm_diffs_per_knot || {})
          .filter(function (stwKey) { return Number(stwKey) >= 6; });

        allSTW.forEach(function (stwKey) {
          const fdm = diffData[key].fdm_diffs_per_knot[stwKey];
          const mdl = diffData[key].model_diffs_per_knot[stwKey];

          newGridData.push({
            value1: value1,
            value2: value2,
            stw: Number(stwKey),
            ...(defaultViewSettings.showAverageMeassured ? {
              powerDiff: fdm && fdm.median_fdm_power !== null ? Number(fdm.median_fdm_power).toFixed(1) : "",
              focDiff: fdm && fdm.median_measured_consumption !== null ? Number(fdm.median_measured_consumption).toFixed(1) : "",
              avgPowerDiff: mdl && mdl.median_power_diff !== null ? mdl.median_power_diff.toFixed(1) : "",
              avgFocDiff: mdl && mdl.median_consumption_diff !== null ? mdl.median_consumption_diff.toFixed(1) : ""
            } : {
              powerDiff2: fdm && fdm.median_fdm_power !== null ? Number(fdm.median_fdm_power).toFixed(1) : "",
              focDiff2: mdl && mdl.mean_consumption_diff !== null ? Number(mdl.mean_consumption_diff).toFixed(1) : ""
            })
          });
        });
      }.bind(this));

      this.results = newResults;
      this.columns = newColumns;
      this.gridData = newGridData;

      this.calcLoading = false;

      this.resultsRenderKey += 1;
      this.scheduleReflow();

      if (this.currentVessel) this.saveVesselState(this.currentVessel);
    }
  }
};
</script>

<style scoped>
.comparisonRoot {
  height: 90vh;
  max-height: 95vh;
  min-height: 95vh;
  width: 100vw;
  max-width: 100vw;
  min-width: 100vw;
  overflow: hidden;
  position: relative;
}

.comparisonRoot * {
  max-width: 100%;
  box-sizing: border-box;
}

.v-data-table {
  background-color: var(--color-bg) !important;
  color: var(--color-text) !important;
}

.v-data-table>>>th {
  background-color: var(--color-primary) !important;
  color: var(--color-text) !important;
  border-bottom: 1px solid var(--color-border) !important;
}

.v-data-table>>>td {
  border-bottom: 1px solid var(--color-border) !important;
  color: var(--color-text) !important;
}

.v-data-table>>>tbody tr:hover {
  background-color: var(--color-overlay) !important;
}

.v-data-table>>>tbody tr:nth-of-type(odd) {
  background-color: var(--color-surface) !important;
}

.v-data-table>>>tbody tr:nth-of-type(even) {
  background-color: var(--color-bg) !important;
}

.v-card {
  background-color: var(--color-surface) !important;
  color: var(--color-text) !important;
}

.v-btn {
  background-color: var(--color-primary) !important;
  color: var(--color-text) !important;
  border-color: var(--color-border) !important;
}

.v-btn:hover {
  background-color: var(--color-primary-light) !important;
}

.v-btn--disabled {
  background-color: var(--color-neutral) !important;
  color: var(--color-text-muted) !important;
}

.v-btn--plain {
  background-color: transparent !important;
  color: var(--color-text) !important;
}

.v-btn--plain:hover {
  background-color: var(--color-overlay) !important;
}

.v-date-picker {
  background-color: var(--color-surface) !important;
  color: var(--color-text) !important;
}

.configRow {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 0;
}

.tableHeader,
.body1,
.h5,
.weather-data-dtn-chart-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rangeInput>>>input {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowView,
.colView {
  min-width: 0;
}

.v-row,
.v-col {
  min-width: 0 !important;
}
</style>
